import { render } from "./Verification.vue?vue&type=template&id=baac8d92&scoped=true"
import script from "./Verification.vue?vue&type=script&lang=js"
export * from "./Verification.vue?vue&type=script&lang=js"

import "./Verification.vue?vue&type=style&index=0&id=baac8d92&scoped=true&lang=css"

import exportComponent from "/var/www/html/resources/sellers/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-baac8d92"]])

export default __exports__